import React from 'react';
import { STATUS_ORDER } from './constants';
import { formatCurrency } from '../../utils/formatters';

type ManagerRowProps = {
  row: any;
  statuses: string[];
  gridStyle: any;
  onToggle: () => void;
  hasCompanySplit: boolean;
};

// Add a helper function to split manager name
function formatManagerName(fullName: string) {
  if (typeof fullName !== 'string' || !fullName.trim()) {
    return (
      <div className="flex flex-col">
        <span>Unassigned</span>
      </div>
    );
  }
  const parts = fullName.split(' ');
  const firstName = parts[0];
  const lastName = parts.slice(1).join(' ');
  return (
    <div className="flex flex-col">
      <span>{firstName}</span>
      <span>{lastName}</span>
    </div>
  );
}

export function ManagerRow({
  row,
  statuses,
  gridStyle,
  onToggle,
  hasCompanySplit,
}: ManagerRowProps) {
  // Only show 'Lost' and 'Booked' for realised revenue
  const realisedStatuses = statuses.filter(s => s === 'Lost' || s === 'Booked');

  return (
    <div
      className="gap-2 px-3 py-1.5 text-xs text-gray-700 grid hover:bg-gray-50"
      style={{ ...gridStyle, cursor: hasCompanySplit ? "pointer" : "default" }}
      onClick={onToggle}
    >
      <div className="font-semibold text-sm w-16">
        {formatManagerName(row.manager)}
      </div>
      <div className="text-center font-medium">{row.nbProjects}</div>
      {statuses.map(status => (
        <div key={"nb-"+status} className="text-center font-medium">{row[status]?.nb || 0}</div>
      ))}
      <div className="text-center font-medium">{row.totalGroups}</div>
      {statuses.map(status => (
        <div key={"est-"+status} className="text-center text-gray-600">
          {formatCurrency(row[status]?.est || 0)}
        </div>
      ))}
      <div className="text-center text-gray-600 font-medium">
        {formatCurrency(row.totalEst)}
      </div>
      <div className="text-center text-gray-600 font-medium">
        {formatCurrency(row.totalReal)}
      </div>
      <div className="text-center text-gray-600 font-medium">
        {row.Booked?.est > 0 ? Math.round((row.totalReal / row.Booked.est) * 100) + '%' : '-'}
      </div>
    </div>
  );
} 